import { GET_CITIES, SET_CITIES, SET_DISPOSITIONSUBCHOICECITIES, GET_DISPOSITIONSUBCHOICECITIES} from "./CitiesType";

const getCities = (state: any) => ({
    type: GET_CITIES,
    state
});

const setCities = (citiesDropDownList: any) => ({
    type: SET_CITIES,
    citiesDropDownList
});

const getDispositionSubChoiceCities = (state: any) => ({
    type: GET_DISPOSITIONSUBCHOICECITIES,
    state
});

const setDispositionSubChoiceCities = (dispositionSubChoiceCitiesDropDownList: any) => ({
    type: SET_DISPOSITIONSUBCHOICECITIES,
    dispositionSubChoiceCitiesDropDownList
});

export {
    getCities,
    setCities,
    getDispositionSubChoiceCities,
    setDispositionSubChoiceCities
}